import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDSwitch from "components/MdSwitch";
import colors from "assets/theme/base/colors";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const onDragEnd = (result, formik, handleReorder) => {
  const { source, destination } = result;
  if (!destination || source.index === destination.index) return;
  handleReorder(source.index, destination.index, formik);
};

const DraggableLinkForm = ({
  formik,
  handleRemoveRegistration,
  handleRegistrationTitleChange,
  handleRegistrationLinkChange,
  handleReorder,
  handleButtonTextChange,
}) => {
  const [switchState, setSwitchState] = useState([]);
  const { sideNav, modal } = colors;

  useEffect(() => {
    setSwitchState(formik.values.event_registration_link.map((link) => link.is_show));
  }, [formik.values.event_registration_link]);

  const handleSwitchChange = (index) => (event) => {
    const newSwitchState = [...switchState];
    newSwitchState[index] = event.target.checked;
    setSwitchState(newSwitchState);

    formik.setFieldValue(`event_registration_link[${index}].is_show`, event.target.checked ? 1 : 0);
  };

  return (
    <DragDropContext onDragEnd={(result) => onDragEnd(result, formik, handleReorder)}>
      <Droppable droppableId="droppable-grid" direction="vertical">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps} className="react-beautiful-dnd">
            {formik.values.event_registration_link.map(
              (registration_link, registration_linkIndex) => (
                <Draggable
                  key={registration_linkIndex}
                  draggableId={`draggable-${registration_linkIndex}`}
                  index={registration_linkIndex}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      //   {...provided.dragHandleProps}
                      style={{
                        ...provided.draggableProps.style,
                        position: "static",
                        marginTop: "20px",
                      }}
                    >
                      <Grid item xs={12} md={12}>
                        <Accordion
                          sx={{
                            boxShadow:
                              "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgb(17 17 26 / 0%) 0px 8px 32px",
                          }}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                          >
                            <MDBox
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <MDBox sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <IconButton
                                  sx={{
                                    padding: "0",
                                    color: sideNav.textColor,
                                  }}
                                  {...provided.dragHandleProps}
                                >
                                  <DragIndicatorIcon sx={{ width: "24px", height: "24px" }} />
                                </IconButton>

                                <MDBox
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    color: sideNav.textColor,
                                    marginTop: "3px",
                                  }}
                                >
                                  Link {registration_linkIndex + 1}
                                  <span
                                    style={{
                                      marginLeft: "10px",
                                      fontWeight: "normal",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {formik?.values?.event_registration_link[registration_linkIndex]
                                      ?.title
                                      ? `(${formik.values.event_registration_link[registration_linkIndex].title})`
                                      : null}
                                  </span>
                                </MDBox>
                              </MDBox>

                              <MDBox
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <MDBox
                                  sx={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    color: sideNav.textColor,
                                    marginTop: "3px",
                                  }}
                                >
                                  {switchState[registration_linkIndex] ? "Show" : "Hide"}
                                </MDBox>
                                <MDSwitch
                                  checked={switchState[registration_linkIndex]}
                                  onChange={handleSwitchChange(registration_linkIndex)}
                                  name={`event_registration_link[${registration_linkIndex}].is_show`}
                                />
                                {formik.values.event_registration_link.length > 1 && (
                                  <IconButton
                                    sx={{
                                      cursor: "pointer",
                                      width: "30px",
                                      height: "30px",
                                      borderRadius: "50px",
                                      transition: "all 0.2s ease-in-out",
                                      color: `${sideNav?.textColor} !important`,
                                      "&:hover": {
                                        backgroundColor: `${modal?.btnHover} !important`,
                                        color: `${modal?.textHover} !important`,
                                      },
                                    }}
                                    onClick={() => handleRemoveRegistration(registration_linkIndex)}
                                  >
                                    <ClearIcon
                                      sx={{
                                        padding: "3px",
                                        width: "25px",
                                        height: "25px",
                                      }}
                                    />
                                  </IconButton>
                                )}
                              </MDBox>
                            </MDBox>
                          </AccordionSummary>

                          <AccordionDetails>
                            <MDBox alignItems="center" sx={{ marginBottom: "20px" }}>
                              <MDInput
                                type="text"
                                label={`Title`}
                                name={`event_registration_link[${registration_linkIndex}].title`}
                                value={registration_link.title}
                                onChange={(e) =>
                                  handleRegistrationTitleChange(
                                    registration_linkIndex,
                                    e.target.value
                                  )
                                }
                                onBlur={formik.handleBlur}
                                sx={{ width: "100%" }}
                                variant="standard"
                              />
                            </MDBox>

                            <MDBox alignItems="center" sx={{ marginBottom: "20px" }}>
                              <MDInput
                                type="text"
                                label={`Link`}
                                name={`event_registration_link[${registration_linkIndex}].link`}
                                value={registration_link.link}
                                onChange={(e) =>
                                  handleRegistrationLinkChange(
                                    registration_linkIndex,
                                    e.target.value
                                  )
                                }
                                onBlur={formik.handleBlur}
                                sx={{ width: "100%" }}
                                variant="standard"
                              />
                            </MDBox>

                            <MDBox alignItems="center">
                              <MDInput
                                type="text"
                                label={`Button title`}
                                name={`event_registration_link[${registration_linkIndex}].button_title`}
                                value={registration_link.button_title}
                                onChange={(e) =>
                                  handleButtonTextChange(registration_linkIndex, e.target.value)
                                }
                                onBlur={formik.handleBlur}
                                sx={{ width: "100%" }}
                                variant="standard"
                              />
                            </MDBox>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>
                    </div>
                  )}
                </Draggable>
              )
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DraggableLinkForm;
